export default {"src":"/_next/static/media/TSLA.187dc69b.svg","height":18,"width":18};